import { useTranslation } from "react-i18next";
import styles from "./css/SpeakButton.module.css";
import { ReactComponent as SpeakerIcon } from "../../img/iconImgAllSpeaker.svg";
import { ReactComponent as SpeakerAbledIcon } from "../../img/iconImgAllSpeakerAbled.svg";

interface SpeakButtonProps {
  fontSize: "small" | "medium" | "large";
  isPlaying: boolean;
  onClick: (e: React.MouseEvent<HTMLDivElement>) => void;
  title?: string;
}

export default function SpeakButton(props: SpeakButtonProps) {
  const { t } = useTranslation();
  function handleOnClickButton(e: React.MouseEvent<HTMLButtonElement>) {
    e.stopPropagation();
    // 마우스로 누른 경우 포커스를 풀어, 학습 화면의 Enter 단축키가 이 버튼을 다시 누르지 않게 한다
    if (e.detail > 0) e.currentTarget.blur();
    props.onClick(e as unknown as React.MouseEvent<HTMLDivElement>);
  }

  function getIconSize(): string {
    switch (props.fontSize) {
      case "small":
        return "24px";
      case "medium":
        return "32px";
      case "large":
        return "40px";
    }
  }

  const tooltip = props.title?.trim() ?? "";

  return (
    <>
      <button
        type="button"
        className={styles.button}
        aria-label={tooltip || t("Pronunciation")}
        data-tooltip={tooltip}
        onClick={handleOnClickButton}
        style={{
          color: props.isPlaying
            ? "var(--icon-active-color)"
            : "var(--icon-secondary-color)",
        }}
      >
        {props.isPlaying ? (
          <SpeakerAbledIcon
            className={styles.icon}
            style={{
              width: getIconSize(),
              height: getIconSize(),
            }}
          />
        ) : (
          <SpeakerIcon className={styles.icon} />
        )}
      </button>
    </>
  );
}
